import { useQuery } from '@tanstack/react-query'
import { useModelStore } from '@editorStores'
import { getRunningTasks } from '@queries'

// Poll interval for the running-tasks endpoint (a redis registry read).
const RUNNING_TASKS_POLL_INTERVAL = 4000
// Faster poll interval while a caller shows the progress of a running task.
const RUNNING_TASKS_FAST_POLL_INTERVAL = 2000

// pollFastWhile: switches to the faster poll interval while it returns true for the
// currently running tasks
const useRunningTasks = (pollFastWhile?: (tasks: RunningTask[]) => boolean) => {
  const projectGuid = useModelStore(state => state.project.guid)

  const { data = [], isFetching } = useQuery<RunningTask[]>({
    queryKey: getRunningTasks.getKey(projectGuid),
    queryFn: () => getRunningTasks.request(projectGuid),
    enabled: !!projectGuid,
    refetchInterval: tasks =>
      tasks && pollFastWhile?.(tasks)
        ? RUNNING_TASKS_FAST_POLL_INTERVAL
        : RUNNING_TASKS_POLL_INTERVAL,
  })

  return { runningTasks: data, isFetching }
}

export default useRunningTasks
